export const AS_REMOVED = "as_removed";
export const INSPECTED = "inspected";
export const NEW_ITEM = "new_item";
export const OVERHAULED = "overhauled";
export const REPAIRED = "repaired";

export const CONDITION_TYPES = {
  [AS_REMOVED]: {
    label: "As Removed"
  },
  [INSPECTED]: {
    label: "Inspected"
  },
  [NEW_ITEM]: {
    label: "New"
  },
  [OVERHAULED]: {
    label: "Overhauled"
  },
  [REPAIRED]: {
    label: "Repaired"
  }
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Dummies/constants.js